// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-about-tsx": () => import("./../../../src/pages/about.tsx" /* webpackChunkName: "component---src-pages-about-tsx" */),
  "component---src-pages-all-tsx": () => import("./../../../src/pages/all.tsx" /* webpackChunkName: "component---src-pages-all-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-pastissues-tsx": () => import("./../../../src/pages/pastissues.tsx" /* webpackChunkName: "component---src-pages-pastissues-tsx" */),
  "component---src-templates-article-tsx": () => import("./../../../src/templates/article.tsx" /* webpackChunkName: "component---src-templates-article-tsx" */),
  "component---src-templates-issue-tsx": () => import("./../../../src/templates/issue.tsx" /* webpackChunkName: "component---src-templates-issue-tsx" */)
}

